export default "/images/sales_refund.png?5fc34a3875def21917b9b9833fc3126a";